import { render, staticRenderFns } from "./collapseCheckboxList.vue?vue&type=template&id=154460fa&"
import script from "./collapseCheckboxList.vue?vue&type=script&lang=js&"
export * from "./collapseCheckboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports